import React from 'react';

import Header from './Header';
import HowSection from './HowSection';
import MediaKitSection from './MediaKitSection';
import WhoSection from './WhoSection';
import WhySection from './WhySection';

const PartnersContent = (): JSX.Element => {
  return (
    <main className="mx-auto max-w-[1060px]">
      <Header />
      <WhySection />
      <WhoSection />
      <HowSection />
      <MediaKitSection />
    </main>
  );
};

export default PartnersContent;
